import { useRef } from "react";
import timeline from "../../../api/peTimeline.json";
import styles from "./ProfessionalExperience.module.scss";
import useInView from "../../../hooks/useInView";

function TimelineRow({ item, animate, delay, isLast }) {
  const isLeft = item.side === "left";
  return (
    <div
      className={`${styles["pe-row"]} ${isLeft ? styles["left"] : styles["right"]}`}
      style={{
        opacity: animate ? 1 : 0,
        transform: animate ? "translateY(0)" : "translateY(24px)",
        transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`,
      }}
    >
      {/* card */}
      <div className={styles["pe-card"]}>
        <div className={styles["pe-card-accent"]} />

        {isLast ? (
          <div className={styles["pe-current-badge"]}>
            <span className={styles["pe-pulse-dot"]} /> Current
          </div>
        ) : (
          <div className={styles["pe-card-year"]}>{item.year}</div>
        )}

        <div className={styles["pe-card-role"]}>{item.role}</div>
        <div className={styles["pe-card-company"]}>{item.company}</div>
        <div className={styles["pe-card-desc"]}>{item.desc}</div>
        <div className={styles["pe-card-tags"]}>
          {item.tags.map((t) => (
            <span key={t} className={styles["pe-card-tag"]}>
              {t}
            </span>
          ))}
        </div>
      </div>

      {/* spine dot */}
      <div className={styles["pe-dot-col"]}>
        <div className={styles["pe-dot"]} />
      </div>

      {/* empty opposite side */}
      <div className={styles["pe-empty"]} />
    </div>
  );
}

export default function ProfessionalExperience() {
  const sectionRef = useRef(null);
  const animate = useInView(sectionRef, 0.06);

  return (
    <>
      <section className={styles["pe-section"]} ref={sectionRef}>
        {/* ── section divider ── */}
        <div
          className={styles["pe-divider"]}
          style={{
            opacity: animate ? 1 : 0,
            transition: "opacity 0.6s ease 0.4s",
          }}
        >
          <div className={styles["pe-divider-line"]} />
          <span className={styles["pe-divider-label"]}>Career Timeline</span>
          <div className={styles["pe-divider-line"]} />
        </div>

        {/* ── timeline ── */}
        <div className={styles["pe-timeline"]}>
          <div className={styles["pe-spine"]} />
          {[...timeline].reverse().map((item, i) => (
            <TimelineRow
              key={item.year}
              item={item}
              animate={animate}
              delay={0.5 + i * 0.12}
              isLast={i === 0}
            />
          ))}
        </div>
      </section>
    </>
  );
}
